import { render, staticRenderFns } from "./Procedimientos.vue?vue&type=template&id=6e81eaae"
import script from "./Procedimientos.vue?vue&type=script&lang=js"
export * from "./Procedimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports